module.exports = __webpack_public_path__ + "img/image-block-2.c5789067.png";